import("../src/javascripts/attachments-redesign");
import("../src/javascripts/easy-toggle");
import("../src/javascripts/tabs");
import("../src/javascripts/slider_splide");
import("../src/javascripts/navigation");
import("../src/javascripts/smooth-scroll-to-anchor");
